export default {
  passport_ru: 'Паспорт РФ',
  passport_ru__hint: 'Cкан/фото всех заполненных страниц',
  snils: `Документ, подтверждающий регистрацию в системе индивидуального (персонифицированного) учета,
     в том числе в форме электронного документа (пенсионное страховое свидетельство/СНИЛС)`,
  tax_identification_number: `Справка из органа государственной налоговой службы о присвоении
    идентификационного номера/ИНН (Идентификационный номер налогоплательщика)`,
  tax_identification_number_ua: `Заверенную личной подписью копию или скан (фото) Справки из
  органа государственной налоговой службы о присвоении идентификационного номера изложить в
  следующей редакции (ИНН/Идентификационный номер налогоплательщика)`,
  tax_identification_number_ua__hint: `
  <a href="https://drive.google.com/drive/folders/1PDtSh3860ckUU5uh6f8UQRnHPrCP1dN2" target="_blank">Образец</a>`,
  employment_history: 'Трудовая книжка: все заполненные страницы',
  employment_history__hint: `Если сотрудник поступает на работу впервые или книжка утеряна -
    необходимо указать это и бухгалтер проинструктирует по дальнейшим шагам после выхода`,
  employment_history_ua: `Трудовая книжка или ведомость о трудовой деятельности з Державного
    реєстру загальнообов’язкового державного соціального страхування (довідка “Дані про трудовий та страховий стаж“)`,
  employment_history_ua__hint: `Если поступаешь на работу впервые или книжка утеряна - необходимо
    указать это и бухгалтер проинструктирует по дальнейшим шагам после выхода`,
  education_document:
    'Документ о специальном образовании (специальности, квалификации) и приложение к диплому о высшем образовании',
  education_document_by: 'Документы об образовании',
  military_registration_document: 'Документы воинского учета, военный билет.',
  military_registration_document__hint:
    'Для военнообязанных и лиц, подлежащих призыву на военную службу (все страницы, где есть запись)',
  disability_certificate: 'Справка/Удостоверение о наличии инвалидности',
  disability_certificate__hint: 'Обязательно при наличии инвалидности',
  child_birth_certificate: 'Свидетельство о рождении ребенка',
  child_birth_certificate__hint: 'Если есть дети до 18 лет',
  child_birth_certificate_ua: 'Свидетельство о рождении ребенка',
  child_birth_certificate_ua__hint: 'Если есть дети до 18 лет',
  child_tax_identification_number: `Копия справки из органа государственной налоговой службы о присвоении
    идентификационного номера на ребенка (ДМС на ребенка оформляется только при предоставленном идентификационном номере ребенка)`,
  passport_by: 'Паспорт РБ или иной документ, удостоверяющий личность',
  passport_by__hint: 'Cкан/фото всех заполненных страниц',
  passport_ua: `Заверенные личной подписью копии (сканы или фото хорошего качества) Паспорта
  гражданина Украины 1-2 стр., 3-6 стр. (если есть записи) или ID-карта с Извлечением из ЕГДР о
  регистрации места жительства`,
  passport_ua__hint: `
  <a href="https://drive.google.com/drive/folders/1SEaoQZOhgLAxkMMb-lfxSbRaII_xp8oU" target="_blank">Образец</a>`,
  '182-n_document': 'Справка 182-Н от всех работодателей за текущий год и предыдущие 2 года',
  '182-n_document__hint': 'Добавить фото/скан, оригинал отправить после выхода',
  '2ndfl_document': 'Справка 2НДФЛ за текущий год',
  '2ndfl_document__hint': 'Если есть дети до 18 лет',
  bank_details: 'Банковские реквизиты для перечисления заработной платы',
  bank_details__hint: 'Обязательно — личные',
  std_documents: 'Справка СТД-ПФР, СТД-Р',
  std_documents__hint: `Фото всех заполненных страниц трудовой книжки, если у последнего работодателя
     был сделан выбор в пользу электронной версии и об этом есть соответствующая отметка`,
  social_insurance_certificate_ua:
    'Свидетельство об общеобязательном государственном социальном страховании (если оно есть)',
  cv_document: 'Резюме',
  benefit_statement: 'Заявление о льготах',
  benefit_statement__hint: 'Заявление о предоставлении налоговой социальной льготы',
  medical_examination_certificate: 'Заключение о пройденном медосмотре',
  medical_examination_certificate__hint: `Для направления на медосмотр, в ответном письме укажи ФИО
    и дату рождения. Наш офис-менеджер свяжется с тобой и сообщит все детали`,
  medical_examination_certificate_ua: 'Заключение о пройденном медосмотре',
  medical_examination_certificate_ua__hint:
    'Актуально для офисных сотрудников, после завершения карантина',
  social_insurance_certificate_by:
    'Страховое свидетельство государственного социального страхования',
  social_insurance_certificate_by__hint: `Если свидетельства нет и не получалось ранее - необходимо
    указать это и бухгалтер проинструктирует по дальнейшим шагам после выхода`,
  bank_details_by: `Реквизиты банковского счета, в “Приорбанке”, т.к. у нас заключен договор с этим
    банком и комиссию за перечисление средств оплачивает компания.`,
  bank_details_by_hint:
    'Для открытия счета в банке нужно указать, что с юридическим лицом заключен зарплатный проект',
  full_name_en: 'Полное имя',
  full_name_en__hint: 'Как в паспорте',
  citizenship: 'Гражданство',
  passport_number: 'Номер паспорта',
  passport_number__hint: 'Если есть загранпаспорт, то его номер',
  residence_address: 'Адрес проживания',
  residence_address__hint: 'Индекс, страна, город, улица, дом и квартира',
  bank_details_en: 'Банковские реквизиты',
  bank_details_en__hintAbove: `Если твой оффер в долларах - нужны реквизиты долларового счета.
    Если твой оффер в евро - еврового. Если валютного счета нет - его нужно обязательно открыть до даты выхода.
    Также можно запросить у банка выписку - они обычно предоставляют ее в формате pdf.`,
  email_plr: 'Электронная почта',
  beneficiary_bank_name: 'Название банка получателя',
  beneficiary_bank_swift: 'SWIFT/BIC банка получателя',
  beneficiary_bank_iban: 'Номер счета получателя',
  intermediary_bank_name: 'Название банка-корреспондента',
  intermediary_bank_swift: 'SWIFT банка корреспондента',
  intermediary_bank_iban: 'Счет в банке корреспонденте',
  photo3x4: 'Фото 3*4',
  photo3x4__hint:
    'Оригинал отправить в бухгалтерию после выхода в компанию после получения запроса',
  rehabilitation_plan: 'Индивидуальный план реабилитации',
  rehabilitation_plan__hint: `Желательно эти документы предоставить заранее, т.к. в плане реабилитации
    могут быть прописаны условия, которые мы не сможем предоставить и, соответственно, не сможем принять на работу.`,
};
